import * as React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Paper,
  Container,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  InputAdornment,
  CssBaseline,
  Button,
  Avatar,
  IconButton,
  Grid,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { useNavigate } from "react-router-dom";

import LoadingComponent from "../CommonComponents/LoadingComponent";

import { LoginAction } from "../../actions/login";
import lock from "../../img/White Lock for login.svg";
import bgImage from "../../img/BG.jpg";
import bgImageNoNyggs from "../../img/BG_NO_NYGGS.jpg";
import loggingLogo from "../../img/White SFA for Login.svg";
import loggingLogoNoNyggs from "../../img/White SFA for Login No Nyggs.svg";

// auth obj
import auth from "../../route/auth";
import { ScheduledAction } from "../../actions/ScheduledMeting";
import { dynamiceForm } from "../../actions/DynamiceForm";
import { companyWiseEmp } from "../../actions/Companywiseclient";

const theme = createTheme({
  palette: {
    primary: {
      main: "#082e6c",
    },
  },
});

const Login = () => {
  const navigate = useNavigate();
  const isNyggsLogo = window.location.hostname.includes("nyggs");
  const [isLoading, setIsLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);

  const fetchshowDistancebyC = () => {
    ScheduledAction.FetchshowcompanyBaseHeader().then((response) => {
      if (response !== null) {
        // setShowHeaderbyCompany(response.data);
        const hrmsUserIddata = JSON.parse(
          localStorage.getItem("data"),
        ).hrmsCompanyId;
        const data = response.data.filter(
          (val) => val.hrmsCompanyId == hrmsUserIddata,
        );
        localStorage.setItem("showHeader", JSON.stringify(data));
      } else {
        console.log("error");
      }
    });
  };

  // const fetchconfigurationdetailsheader = () => {
  //   const data = {
  //     hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId
  //   }
  //   ScheduledAction.configurationdetails(data).then((response) => {
  //     localStorage.setItem("configurationdetailsheader", response.data)
  //   })
  // }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get("email");
    const password = data.get("password");
    const companyToken = data.get("companyToken");
    if (email.trim()) {
      if (password.trim()) {
        // if (companyToken.trim()) {
        setIsLoading(true);
        const res = await LoginAction.fetchLoginData({
          userName: email,
          password,
          companyToken: companyToken.trim() || null,
        });

        if (res !== null && res.responseCode === 200) {
          res.data["companyToken"] = companyToken;
          localStorage.setItem("data", JSON.stringify(res.data));
          // ScheduledAction.FetchshowcompanyBaseHeader().then((response) => {
          //   if (response !== null) {
          debugger;
          //     // setShowHeaderbyCompany(response.data);
          const Templatedata = {
            companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
            templateTypeId: 5,
          };

          //     localStorage.setItem("showHeader", JSON.stringify(response.data.filter(
          //       (val) => val.hrmsCompanyId == hrmsUserIddata
          //     ).length == 0 ? false : true));
          //   } else {
          //     console.log("error");
          //   }
          // });

          const sitePayload = {
            companyId: res.data?.hrmsCompanyId || null,
            hrmsToken: res.data?.hrmsToken,
            hrmsUserId: res.data?.hrmsUserId,
            userId: res.data?.id,
          };
          console.log(res.data);
          const siteRes = await companyWiseEmp.getUserSites(sitePayload);
          if (
            siteRes &&
            siteRes.responseCode === 200 &&
            siteRes?.data?.length > 0
          ) {
            if (res?.data?.isSiteConfigEnabled) {
              const tempData =
                siteRes?.data &&
                siteRes?.data?.map((ele) => ({
                  id: ele?.siteId,
                  name: ele?.siteName,
                  code: ele?.code,
                  isHeadQuarter: ele?.isHeadQuarter,
                  companyId: ele?.companyId,
                }));
              localStorage.setItem(
                "sites",
                JSON.stringify([{ id: null, name: "All" }, ...tempData]),
              );
              localStorage.setItem(
                "selectedSite",
                JSON.stringify({ id: null, name: "All" }),
              );
            }
            // else {
            //   localStorage.setItem("sites", JSON.stringify([selectedSite]));
            // }
            // localStorage.setItem("selectedSite", JSON.stringify(selectedSite));
          }
          console.log(siteRes);

          dynamiceForm.fetchGetSaveTempalte(Templatedata).then((response) => {
            if (response !== null) {
              debugger;
              localStorage.setItem(
                "Templatedata",
                JSON.stringify(
                  response.data && response.data.templateDateForAindroid,
                ),
              );
              auth.login(() => {
                navigate("/dashboard");
              });
            } else {
              auth.login(() => {
                navigate("/dashboard");
              });
            }
            auth.login(() => {
              navigate("/dashboard");
            });
          });

          sessionStorage.setItem("auth", "true");
        } else {
          alert("Invalid Email or Passsword and Company Identifier ");
        }
        // }
        // else {
        //   alert("Please Enter a valid Company Identifier!!");
        // }
      } else {
        alert("Please Enter a valid Password");
      }
    } else {
      alert("Please Enter a valid Emp Code!!");
    }
    setIsLoading(false);
  };

  React.useEffect(() => {
    const tokenResponse = getAndValidateTokenFromParams();
    if (tokenResponse !== null) {
      const empCode = document.getElementById("email");
      const password = document.getElementById("password");
      const companyToken = document.getElementById("companyToken");
      empCode.value = tokenResponse.userName;
      password.value = tokenResponse.password;
      companyToken.value = tokenResponse.companyToken;
      document.getElementById("submit").click();
    }
  }, []);

  return (
    <main
      className="login__main"
      style={{
        backgroundImage: `url(${isNyggsLogo ? bgImage : bgImageNoNyggs})`,
      }}
    >
      <LoadingComponent isLoading={isLoading} />
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs" className="login_parent">
          <CssBaseline />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              className: "loggingBox",
              // borderTopLeftRadius:"20px",
              // borderTopRightRadius:"20px"
              borderRadius: "20px",
              boxShadow: "0px 0px 20px 0px #0000004f !important",
              // padding: "1rem 2rem",
            }}
            component={Paper}
            className="loggingbox"
          >
            {/* <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar> */}
            {/* <Typography component="h1" variant="h5" required>
              Sign in
            </Typography> */}
            <div className="loggingHeader">
              <Grid
                item
                conatiner
                xs={12}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid
                  item={4}
                  style={{
                    marginLeft: "8px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img src={lock} alt="" style={{ width: "18%" }} />
                  <span className="spantext">Sign In</span>
                </Grid>
                <Grid item={4}>{/* <img src={lock} alt=""/> */}</Grid>
                <Grid item={4}>
                  <img
                    src={isNyggsLogo ? loggingLogo : loggingLogoNoNyggs}
                    alt=""
                    style={{ width: "50%" }}
                  />
                </Grid>
              </Grid>
            </div>
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1 }}
              className="inputbox logininput"
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Employee Code"
                name="email"
                // autoComplete="email"
                // autoFocus
                className="inputText"
              />
              <TextField
                className="inputText"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type={visible ? "text" : "password"}
                id="password"
                // autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setVisible(!visible)}
                      >
                        {visible ? <VisibilityOffIcon /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                margin="normal"
                fullWidth
                name="companyToken"
                label="Company Identifier"
                id="companyToken"
                required="hiii"
                // autoComplete="companyToken"
              />
              {/* <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              /> */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 2, mb: 1 }}
                className="loogintext"
                id="submit"
              >
                Sign In
              </Button>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </main>
  );
};

function getAndValidateTokenFromParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");

  if (!token) {
    console.warn("Token parameter not found in URL.");
    return null;
  }

  try {
    const paddedToken = token.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = atob(paddedToken);
    const json = JSON.parse(decoded);

    const requiredKeys = ["companyToken", "userName", "password"];
    const hasAllKeys = requiredKeys.every((key) => key in json && json[key]);

    if (hasAllKeys) {
      return json;
    }

    return null;
  } catch (error) {
    console.error("Invalid base64 token or malformed JSON:", error);
    return null;
  }
}

export default Login;
